/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IEmployeeBranch, IPerson } from '../../api/domain';

enum CustomerMasterDataApiActions {
    FETCH_USER_PERSON = 'customer-master-data-api.fetch.user-person',
    FETCH_USER_PERSON_SUCCESS = 'customer-master-data-api.fetch.user-person-success',
    FETCH_USER_PERSON_FAILURE = 'customer-master-data-api.fetch.user-person-failure',

    FETCH_CUSTOMER_BRANCH = 'customer-master-data-api.fetch.customer-branch',
    FETCH_CUSTOMER_BRANCH_SUCCESS = 'customer-master-data-api.fetch.customer-branch-success',
    FETCH_CUSTOMER_BRANCH_FAILURE = 'customer-master-data-api.fetch.customer-branch-failure',
}

export const fetchCustomerBranch = createAction<string>(CustomerMasterDataApiActions.FETCH_CUSTOMER_BRANCH);
export const fetchCustomerBranchSuccess = createAction<IEmployeeBranch>(CustomerMasterDataApiActions.FETCH_CUSTOMER_BRANCH_SUCCESS);
export const fetchCustomerBranchFailure = createAction(CustomerMasterDataApiActions.FETCH_CUSTOMER_BRANCH_FAILURE);

export const fetchUserPerson = createAction(CustomerMasterDataApiActions.FETCH_USER_PERSON);
export const fetchUserPersonSuccess = createAction<IPerson>(CustomerMasterDataApiActions.FETCH_USER_PERSON_SUCCESS);
export const fetchUserPersonFailure = createAction(CustomerMasterDataApiActions.FETCH_USER_PERSON_FAILURE);

